import { Lead } from "../lead/lead.js";
const lead = new Lead();
window.lead = lead;

let menuBtn = document.querySelector('.header-main__info-burger');
let menu = document.querySelector('.header-main__nav');
let body = document.querySelector('body');

menuBtn.addEventListener('click', function(){
	menuBtn.classList.toggle('active');
	menu.classList.toggle('active');
	body.classList.toggle('no-scroll');
});

$(document).ready(function() {
    if (typeof flatpickr !== 'undefined') {
        console.log("Flatpickr загружен успешно");

        try {
            $("input[name='str_child_birthday']").flatpickr({
                dateFormat: "Y.m.d", // Формат для отправки на сервер
				altFormat: "d.m.Y",
                altInput: false,      // Отключаем удобное отображение
                locale: "ru",         // Устанавливаем русский язык
            });
            console.log("Flatpickr инициализирован");
        } catch (error) {
            console.error("Ошибка при инициализации Flatpickr:", error);
        }
    } else {
        console.error("Flatpickr не загружен");
    }
});

$(document).ready(function () {
	const consentKey = "cookieConsent";
	const consentBanner = $("#cookie-consent");
	const acceptButton = $("#accept-cookie");

	// Проверяем, дал ли пользователь согласие
	if (!localStorage.getItem(consentKey)) {
		consentBanner.show();
		}

		// При нажатии на кнопку сохраняем выбор пользователя
		acceptButton.on("click", function () {
		localStorage.setItem(consentKey, "true");
		consentBanner.hide();
	});
});

//MAPS//
$('.mapContainer').each(function() {
	var mapTitle = $('<div>').addClass('mapTitle');
	mapTitle.text('Для активации карты нажмите по ней');
	$(this).append(mapTitle);

	$(this).on('click', function() {
		$(this).children(':first').removeAttr('style');
		mapTitle.remove();
	});

	$(this).on('mousemove', function(event) {
		mapTitle.css('display', 'block');
		if (event.offsetY > 10) mapTitle.css('top', event.offsetY + 20 + 'px');
		if (event.offsetX > 10) mapTitle.css('left', event.offsetX + 20 + 'px');
	});

	$(this).on('mouseleave', function() {
		mapTitle.css('display', 'none');
	});
});
//MAPS//

$(window).scroll(function() {
	if ($(this).scrollTop() > 50) {
		$('.to-top').addClass('scrolled');
	} else {
		$('.to-top').removeClass('scrolled');
	}
});

$('.tab-navigation-btn').click(function() {
	var id = $(this).attr('data-tab'),
		content = $('.tabcontent-main[data-tab="'+ id +'"]');
	
	$('.tab-navigation-btn.active').removeClass('active');
	$(this).addClass('active');
	
	$('.tabcontent-main.active').removeClass('active');
	content.addClass('active');
});

// $('.schedule-block-preview-item-btn').click(function() {
// 	var id = $(this).attr('data-tab'),
// 		content = $('.schedule-block__content[data-tab="'+ id +'"]');
	
// 	$('.schedule-block-preview-item-btn.active').removeClass('active');
// 	$(this).addClass('active');
	
// 	$('.schedule-block__content.active').removeClass('active');
// 	content.addClass('active');
// });

$('.schedule-block-course-item-btn').click(function() {
	var id = $(this).attr('data-tab'),
		content = $('.schedule-block-main[data-tab="'+ id +'"]');
	
	$('.schedule-block-course-item-btn.active').removeClass('active');
	$(this).addClass('active');
	
	$('.schedule-block-main.active').removeClass('active');
	content.addClass('active');
});

// $('.schedule-block-main-nav-item-btn').click(function() {
// 	var id = $(this).attr('data-tab'),
// 		content = $('.schedule-block-main-content[data-tab="'+ id +'"]');
	
// 	$('.schedule-block-main-nav-item-btn.active').removeClass('active');
// 	$(this).addClass('active');
	
// 	$('.schedule-block-main-content.active').removeClass('active');
// 	content.addClass('active');
// });

// Обработчик событий для кнопок внутри .championship-block-main-nav-item-btn в блоке с data-tab="1"
$('.schedule-block-main[data-tab="1 курс"] .schedule-block-main-nav-item-btn').click(function() {
	var id = $(this).attr('data-tab'),
		content = $('.schedule-block-main[data-tab="1 курс"] .schedule-block-main-content[data-tab="' + id + '"]');

	$('.schedule-block-main[data-tab="1 курс"] .schedule-block-main-nav-item-btn.active').removeClass('active');
	$(this).addClass('active');

	$('.schedule-block-main[data-tab="1 курс"] .schedule-block-main-content.active').removeClass('active');
	content.addClass('active');
});

// Обработчик событий для кнопок внутри .championship-block-main-nav-item-btn в блоке с data-tab="1"
$('.schedule-block-main[data-tab="2 курс"] .schedule-block-main-nav-item-btn').click(function() {
	var id = $(this).attr('data-tab'),
		content = $('.schedule-block-main[data-tab="2 курс"] .schedule-block-main-content[data-tab="' + id + '"]');

	$('.schedule-block-main[data-tab="2 курс"] .schedule-block-main-nav-item-btn.active').removeClass('active');
	$(this).addClass('active');

	$('.schedule-block-main[data-tab="2 курс"] .schedule-block-main-content.active').removeClass('active');
	content.addClass('active');
});

// Обработчик событий для кнопок внутри .championship-block-main-nav-item-btn в блоке с data-tab="1"
$('.schedule-block-main[data-tab="3 курс"] .schedule-block-main-nav-item-btn').click(function() {
	var id = $(this).attr('data-tab'),
		content = $('.schedule-block-main[data-tab="3 курс"] .schedule-block-main-content[data-tab="' + id + '"]');

	$('.schedule-block-main[data-tab="3 курс"] .schedule-block-main-nav-item-btn.active').removeClass('active');
	$(this).addClass('active');

	$('.schedule-block-main[data-tab="3 курс"] .schedule-block-main-content.active').removeClass('active');
	content.addClass('active');
});

// Обработчик событий для кнопок внутри .championship-block-main-nav-item-btn в блоке с data-tab="1"
$('.schedule-block-main[data-tab="4 курс"] .schedule-block-main-nav-item-btn').click(function() {
	var id = $(this).attr('data-tab'),
		content = $('.schedule-block-main[data-tab="4 курс"] .schedule-block-main-content[data-tab="' + id + '"]');

	$('.schedule-block-main[data-tab="4 курс"] .schedule-block-main-nav-item-btn.active').removeClass('active');
	$(this).addClass('active');

	$('.schedule-block-main[data-tab="4 курс"] .schedule-block-main-content.active').removeClass('active');
	content.addClass('active');
});

// Обработчик событий для кнопок внутри .championship-block-nav-item-btn
$('.championship-block-nav-item-btn').click(function() {
	var id = $(this).attr('data-tab'),
		content = $('.championship-block-main[data-tab="' + id + '"]');

	$('.championship-block-nav-item-btn.active').removeClass('active');
	$(this).addClass('active');

	$('.championship-block-main.active').removeClass('active');
	content.addClass('active');
});

// Обработчик событий для кнопок внутри .championship-block-main-nav-item-btn в блоке с data-tab="1"
$('.championship-block-main[data-tab="1"] .championship-block-main-nav-item-btn').click(function() {
	var id = $(this).attr('data-tab'),
		content = $('.championship-block-main[data-tab="1"] .championship-block-main-content[data-tab="' + id + '"]');

	$('.championship-block-main[data-tab="1"] .championship-block-main-nav-item-btn.active').removeClass('active');
	$(this).addClass('active');

	$('.championship-block-main[data-tab="1"] .championship-block-main-content.active').removeClass('active');
	content.addClass('active');
});

// Обработчик событий для кнопок внутри .championship-block-main-nav-item-btn в блоке с data-tab="2"
$('.championship-block-main[data-tab="2"] .championship-block-main-nav-item-btn').click(function() {
	var id = $(this).attr('data-tab'),
		content = $('.championship-block-main[data-tab="2"] .championship-block-main-content[data-tab="' + id + '"]');

	$('.championship-block-main[data-tab="2"] .championship-block-main-nav-item-btn.active').removeClass('active');
	$(this).addClass('active');

	$('.championship-block-main[data-tab="2"] .championship-block-main-content.active').removeClass('active');
	content.addClass('active');
});

$('[data-fancybox]').fancybox({
	infinite: false,
	backFocus: false,
	trapFocus: false,
	placeFocusBack: false,
	buttons : ['close'],          
});
// Get the element with id="defaultOpen" and click on it
// document.getElementById("defaultOpen").click();

if(window.innerWidth > 1680){
	$('.card-block__list:has(.card-block__item:nth-child(5))').css('grid-template-columns', 'repeat(15, 1fr)');
};

// if(window.innerWidth > 1680){
// 	$('.popular-card-block-list:has(.popular-card-block-item:nth-child(5))').css('grid-template-columns', 'repeat(15, 1fr)');
// };

// Resize
$(window).on("resize", function () {

});


// Scroll
$(window).on("scroll", function () {

})


// Document click
$(document).on("click", function (e) {

});


// popups
$(".popup__close, .popup__cancel").on("click", function (e) {
	$("body").removeClass("no-scroll");
	$(this).closest(".popup").removeClass("active");
});

$(".popup").on("click", function (e) {
	var callbackPopup = $(".popup__card")
	if (!callbackPopup.is(e.target) && callbackPopup.has(e.target).length === 0) {
		$(this).removeClass("active");
		$("body").removeClass("no-scroll");
	};
});

$("[data-popup-open]").on("click", function (e) {
	e.preventDefault();
	let dataPopupName = $(this).attr("data-popup-open");
	let popup = $(".popup[data-popup-name=" + dataPopupName + "]");
	$("body").addClass("no-scroll");
	popup.addClass("active");
});  